import styles from '../../pages/admin/ClubRecords/ClubRecords.module.css';
import React from 'react';
import { UserPermissionLevel } from 'constants/auth';
import TableActionButtons from 'components/NewDesign/TableActionButtons';

export const dataTypeOptions = [
  { value: 'published', label: 'Official Records' },
  {
    value: 'pending',
    label: 'Pending Records',
    permissionLevel: UserPermissionLevel.Official,
  },
];

// Helper function to render track surface badge
const renderTrackSurfaceBadge = (surface) => {
  if (!surface) return null;

  const getBadgeClass = (surface) => {
    switch (surface) {
      case 'Synthetic':
        return `${styles.trackSurfaceBadge} ${styles.synthetic}`;
      case 'Grass':
        return `${styles.trackSurfaceBadge} ${styles.grass}`;
      case 'Dirt':
        return `${styles.trackSurfaceBadge} ${styles.dirt}`;
      default:
        return styles.trackSurfaceBadge;
    }
  };

  return <span className={getBadgeClass(surface)}>{surface}</span>;
};

// Filtering happens at page level (event/age/gender dropdowns + athlete
// search on the Club Records page), so no column carries dialog-filter
// config — these are plain display columns.
const cellPadding = {
  paddingLeft: 20,
  paddingRight: 20,
};

const baseColumns = [
  {
    accessor: 'eventType',
    label: 'Event',
    headerStyle: cellPadding,
    style: cellPadding,
  },
  {
    accessor: 'trackSurface',
    label: 'Track Surface',
    headerStyle: cellPadding,
    style: cellPadding,
    Cell: ({ value }) => renderTrackSurfaceBadge(value),
  },
  {
    accessor: 'ageGroup',
    label: 'Age Group',
    groupColumn: 'group', // the group a record is for: AdminDataTable heads and shows it in the club's terms
    headerStyle: cellPadding,
    style: cellPadding,
  },
  {
    accessor: 'gender',
    label: 'Gender',
    headerStyle: cellPadding,
    style: cellPadding,
  },
  {
    accessor: 'result',
    label: 'Result',
    headerStyle: cellPadding,
    style: cellPadding,
  },
  {
    accessor: 'athleteName',
    label: 'Athlete',
    headerStyle: cellPadding,
    style: cellPadding,
  },
  {
    accessor: 'timestamp',
    label: 'Date',
    headerStyle: cellPadding,
    style: cellPadding,
  },
];

// Function to generate published columns with action handlers
export const getPublishColumns = (onEdit, onDelete) => [
  ...baseColumns,
  {
    accessor: 'actions',
    label: 'Actions',
    headerStyle: cellPadding,
    style: cellPadding,
    Cell: ({ row }) => TableActionButtons(row, onEdit, onDelete),
  },
];

// Published columns without the Actions column (read-only view)
export const publishColumns = [...baseColumns];

export const pendingColumns = [
  ...baseColumns,
  {
    accessor: 'buttons',
    label: '',
    headerStyle: cellPadding,
    style: cellPadding,
  },
];
